import { combineReducers } from 'redux';

// Reducers
import account from './account';
import layout  from './layout';
import user    from './user';

export default combineReducers({
	account,
	layout,
	user
});